<template>
    <div>
        <agent-selector :reservation="reservation"></agent-selector>

        <div class="bg-lightest dark font-weight-600 px-3 py-3 fs-small d-flex flex-row align-items-center justify-content-between pointer w-100">
            <div class="d-flex flex-row align-items-center">
                <i class="ico ico-ticket color-6 fs-larger"></i>
                <span>VOUCHER CODE</span>
            </div>
            <div class="w-50 d-flex justify-content-end">
                <input type="text" class="w-100 px-2 py-1" v-model="reservation.BookingOperatorCode">
            </div>
        </div>

        <cost-list :reservation="reservation" :noTicketsSelected="noTicketsSelected"></cost-list>

        <!-- Promocode -->
        <promocode-input :reservation="reservation" :enablePromocode="true" class="mt-2"></promocode-input>

        <total-and-pay :reservation="reservation" :selectedAgentComissions="selectedAgentComissions" :noTicketsSelected="noTicketsSelected"></total-and-pay>

    </div>
</template>

<script>
import AgentSelector from './Summary/AgentSelector'
import CostList from './Summary/CostList'
import TotalAndPay from './Summary/TotalAndPay'
import PromocodeInput from '@/tools/promocode/promocodeInput'
export default {
    data: function() {
        return {
            bookingGenderPrices: null
        }
    },
    props: {
        reservation: {
            type: Object
        },
        selectedAgentComissions: {
            type: Object,
            default: null
        }
    },
    created: function() {
        this.bookingGenderPrices = this.reservation.bookingGenderPrices
    },
    computed: {
        noTicketsSelected: function() {
            let output = true;
            for(let personTypes of this.bookingGenderPrices){
                if(personTypes.quantityToBook > 0){
                    output = false;
                }
            }

            return output;
        }
    },
    methods: {
    },
    components: {
        AgentSelector,
        CostList,
        TotalAndPay,
        PromocodeInput
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// ReservationSummary.vue?5acd0dfe